export default function SectionTitle({ className = '', label = '' }) {
  return (
    <div className={`${className} text-[26px] md:text-[28px] font-medium`}>
      {label}
    </div>
  );
}
